import React from 'react'
import { WarningCircle, X }from "@phosphor-icons/react";
export default function MainSaveModal(props) {

    const onClose = () => {
        try{
            props.setMainSaveModal(false);
        }catch(error){
            console.log(error);
        }
    }

    const finalClose = ()=>{
        try{
            props.setMainSaveModal(false);
            props.manageGuestModal(false);
            props.setRoomId("");
            props.setBookedRoomsData(null);
            props.setBookingData(null);
        
        }catch(error){
            console.log(error);
        }

    }
 
  return (
    <div className="fixed inset-0 flex items-center justify-center z-[1002] bg-black bg-opacity-50">
        <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
            
            <div className='flex items-center justify-between'>
                <div className='flex items-center gap-2'>
                    <WarningCircle size={24} className="text-yellow-500"/>
                    <h2 className='font-bold'>
                        Unsaved Changes
                    </h2>
                </div>
                {/* Close Button */}
                <button 
                    className=" text-gray-500 hover:text-gray-800"
                    onClick={()=>onClose()}
                >
                    <X size={20} />
                </button>
            </div>

            <div className='mt-6'>
                <p className='text-sm'>
                    Please save the changes of your room by clicking on the <br /> Update Room / Booking
                </p>
                <button className='mt-4 text-sm bg-red-500 text-white p-3 rounded-md shadow-sm' onClick={()=>finalClose()}>
                    Close Without Saving
                </button>
            </div>

        </div>
    </div>
  )
}
